import React from 'react'
import Link from '@mui/material/Link';
function Developed() {

  return (
    <span>
      Web Design & Development by <Link href="https://webexpressions.net/" target="_blank" rel="noopener" style={{ color: 'inherit' }}>Web Expressions, LLC</Link>
    </span>
  )
}

export default Developed